// スクリーニング(セグメント) 地域セグメント表示内容保存
export const RESULT_DATA_SET =
  "tools/screening/segment/area/result-data/RESULT_DATA_SET";
// スクリーニング(セグメント) 地域セグメント表示内容クリア
export const RESULT_DATA_CLEAR =
  "tools/screening/segment/area/result-data/RESULT_DATA_CLEAR";
